import type { ExternalTableSchema } from '@packages/table-builder';

export const participantBankTable: ExternalTableSchema = {
  metadata: {
    title: 'Bank Account List',
    entity: 'ParticipantBank',
    description: 'Participant bank accounts pending verification.',
  },

  dataSource: {
    endpoint:
      '/api/finance-integration/api/app/participant-bank-job/participant-bank-list-for-verification',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
      CompanyId: 'filters.CompanyId',
      BankVerificationStatusId: 'filters.BankVerificationStatusId',
    },
    saveEndpoint:
      '/api/finance-integration/api/app/participant-bank-job/participant-bank-list-for-verification',
    saveMethod: 'PUT',
    onSaveSuccess: 'toastAndRefetch',
    saveSuccessMessage: 'Bank Account Edited.',
    confirmBeforeSave: {
      title: 'Are you sure you want to save the status of the bank account?',
      message: 'This action cannot be undone.',
      variant: 'warning',
    },
    filters: [
      {
        name: 'CompanyId',
        semanticId: 'companyId',
        placeholder: 'Company',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/customer/api/app/participant-broker-account/company-list',
          labelField: 'companyName',
          valueField: 'id',
        },
      },
      {
        name: 'BankVerificationStatusId',
        semanticId: 'status',
        placeholder: 'Status',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/finance-integration/api/app/participant-bank-job/bank-verification-status',
          labelField: 'displayName',
          valueField: 'id',
        },
      },
    ],
  },

  columns: [
    {
      field: 'companyName',
      header: 'Company',
      type: 'text',
      sortable: true,
      width: 220,
    },
    {
      field: 'accountNumber',
      header: 'Account Number',
      type: 'text',
      sortable: true,
      width: 180,
    },
    {
      field: 'nameOnAccount',
      header: 'Account Holder Name',
      type: 'text',
      sortable: true,
      width: 220,
    },
    {
      field: 'routingType',
      header: 'Routing Type',
      type: 'text',
      sortable: true,
      width: 140,
    },
    {
      field: 'routingNumber',
      header: 'Routing Number',
      type: 'text',
      sortable: true,
      width: 280,
    },
    {
      field: 'accountType',
      header: 'Account Type',
      type: 'text',
      sortable: true,
      width: 220,
    },
    {
      field: 'institutionName',
      header: 'Institution Name',
      type: 'text',
      sortable: true,
      width: 220,
    },
    {
      field: 'ticker',
      header: 'Ticker',
      type: 'text',
      sortable: true,
      width: 180,
    },
    {
      field: 'status',
      header: 'Status',
      type: 'badge',
      sortable: true,
      width: 180,
      align: 'center',
      badge: {
        statusMap: {
          Verified: 'success',
          'Pending Broker': 'info',
          'Broker Received': 'info',
          Rejected: 'error',
        },
        defaultVariant: 'info',
      },
      editable: { type: 'asyncSelect', defaultValueField: 'status' },
      dataSource: {
        url: '/api/finance-integration/api/app/participant-bank-job/bank-verification-status',
        mapper: { label: 'displayName', value: 'displayName' },
      },
    },
  ],

  actions: {
    row: [{ id: 'EDIT_ROW_PARTICIPANT_BANK', label: 'Edit', actionType: 'startEditing' }],
    bulk: [{
      id: 'SAVE_STATUS_PARTICIPANT_BANK',
      label: 'Save',
      endpoint: '/api/finance-integration/api/app/participant-bank-job/participant-bank-list-for-verification',
      method: 'PUT',
      onSuccess: 'toastAndRefetch',
      successMessage: 'Bank Account Edited.',
      dialog: {
        title: 'Are you sure you want to save the status of the bank account?',
        message: 'This action cannot be undone.',
        variant: 'warning',
      },
    }],
  },

  features: {
    search: { enabled: true, placeholder: 'Search' },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    editing: { bulkSave: true },
  },
};
